
export let isIosDevice = (customers, customerFullUserId) => {
    let currentCustomers = {}
    if (customers) {
        currentCustomers = customers.current
    }

    let currentCustomer = currentCustomers.filter((v) => {
        return v.userId === customerFullUserId
    })

    if (currentCustomer && currentCustomer.length > 0) {
        return currentCustomer[0].deviceType === "ios"
    }
    return false;
}